import { Action, Module, VuexModule } from 'vuex-module-decorators'
import DefaultNeeds from '@master/config/default-needs.json'
import API from '@core/services/API'
import { inject } from 'inversify-props'

@Module({
  namespaced: true
})
export default class ProductStore extends VuexModule {
   @inject()
  protected $api: API

  @Action
   async getProductListNeeds () {
     const { value } = await this.$api.kvm.get({
       key: 'globalproducts_needs_abc'
     })
     const needsList = value ? JSON.parse(value) : DefaultNeeds
     return [...(new Set(needsList))]
   }
}
